<template>
  <div
    v-show="showExtendedInfo && extendedInfoData?.length"
    class="absolute bottom-[49px] left-[50px]"
  >
    <wui-card
      state="text"
      shadow="overflow"
    >
      <wui-list>
        <wui-list-item
          v-for="item in extendedInfoData"
          :key="item.slug"
          class="flex gap-5 justify-between"
          :disabled="loading"
          @click="onClick(item)"
        >
          <span>{{ item.title }}</span>
          <wui-chip
            rounded
            variant="brand"
            :label="`/${item.slug}`"
          />
        </wui-list-item>
        <template #footer>
          <wui-list-item @click="close()">
            {{ $t('common.close') }}
          </wui-list-item>
        </template>
      </wui-list>
    </wui-card>
  </div>
</template>
<script setup lang="ts">
import { WuiCard, WuiChip, WuiList, WuiListItem } from '@wui/common-library'
import { PServed } from '@wui/im'
import { toRef } from 'vue'

import { useLoading } from '@/shared/composables/use-loading'

import { useExtendedInfo } from '../lib'
import { ExtendedInfoItem } from '../types'

const props = defineProps<{
  pServed: PServed
}>()

const pServed = toRef(props, 'pServed')

const { extendedInfoData, processExtendedInfo, showExtendedInfo } = useExtendedInfo(pServed)
const { loading, startLoading, stopLoading } = useLoading()
const onClick = async (item: ExtendedInfoItem) => {
  if (loading.value) {
    return
  }
  startLoading()
  await processExtendedInfo(item)
  close()
  stopLoading()
}

const close = () => {
  showExtendedInfo.value = false
}
</script>
